<template lang="pug">
  .pane.payment-options(:class="objectClass")
    .pane__header Вариант оплаты
    .pane__body
      .payment-options__container

        .payment-options__radio-wrapper
          label.payment-options-radio(:class="{'checked': value === ONLINE}")
            input(
              @input="setPaymentOption($event.target.value)"
              :value="ONLINE"
              type="radio"
              name="payment"
              v-model="value"
            )
            div.payment-options-radio__bg
            v-icon.payment-options-radio__icon(name="globe")
            span {{ONLINE.title}}

        .payment-options__radio-wrapper
          label.payment-options-radio(:class="{'checked': value === CASH}")
            input(
              @input="setPaymentOption($event.target.value)"
              :value="CASH"
              type="radio"
              name="payment"
              v-model="value"
            )
            div.payment-options-radio__bg
            svg.payment-options-radio__icon.payment-options-radio__svg-icon(
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            )
              path(d="M3 6v12c0 1.1.9 2 2 2h16v-4M3 6c0 1.1.9 2 2 2h14M3 6c0-1.1.9-2 2-2h14v4m0 0h2v4M16 14c0-1.1.9-2 2-2h4v4h-4a2 2 0 0 1-2-2z")
            span {{CASH.title}}

        .payment-options__radio-wrapper
          label.payment-options-radio(:class="{'checked': value === CERT}")
            input(
              @click="focusCertNumberInput"
              :value="CERT"
              type="radio"
              name="payment"
              v-model="value"
            )
            div.payment-options-radio__bg
            svg.payment-options-radio__icon.payment-options-radio__svg-icon(
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="0"
              stroke-linecap="round"
              stroke-linejoin="round"
            )
              path(
                d="M22.981 5.47547H17.7835C18.5988 4.55436 19.0574 3.42854 19.0574 2.45629C19.0574 1.73989 18.8026 1.12582 18.344 0.665262C17.8854 0.255848 17.2229 0 16.5096 0C15.3886 0 14.0637 0.562884 13.0446 1.58637C12.586 1.99574 12.2293 2.50748 11.9746 2.96804C11.7198 2.50748 11.3631 1.99574 10.9045 1.58637C9.88535 0.614073 8.56053 0 7.43949 0C6.67516 0 6.06369 0.204707 5.60509 0.665262C5.14649 1.07463 4.89173 1.73989 4.89173 2.45629C4.89173 3.42859 5.4013 4.55436 6.21656 5.47547H1.01909C0.4586 5.47547 0 5.93603 0 6.49891V11.5138C0 12.0768 0.4586 12.5373 1.01909 12.5373H2.54776V22.9766C2.54776 23.5394 3.00636 24 3.56685 24H20.3822C20.9427 24 21.3503 23.5394 21.4013 23.0277V12.5373H22.9299C23.4904 12.5373 23.949 12.1279 24 11.5139V6.49891C24 5.93603 23.5414 5.47547 22.981 5.47547ZM14.4204 2.96799C15.0828 2.35392 15.8981 1.94455 16.5096 1.94455C16.6115 1.94455 16.8153 1.94455 16.9682 2.04688C17.0701 2.09807 17.0701 2.30273 17.0701 2.4051C17.0701 2.86566 16.7644 3.63325 16 4.40084C15.3376 5.01492 14.5223 5.42433 13.9109 5.42433C13.758 5.42433 13.5542 5.42433 13.4523 5.322C13.3504 5.27081 13.3504 5.06615 13.3504 4.96377C13.3504 4.50317 13.6561 3.73558 14.4204 2.96799ZM6.98089 2.04693C7.13376 1.9446 7.33759 1.9446 7.43949 1.9446C8.05096 1.9446 8.86626 2.35396 9.52865 3.01923C10.344 3.78682 10.5987 4.55441 10.5987 5.01496C10.5987 5.11729 10.5987 5.27081 10.4968 5.37319C10.344 5.47552 10.1401 5.47552 10.0382 5.47552C9.42675 5.47552 8.61145 5.06615 7.94906 4.45208C7.13376 3.68449 6.87899 2.9169 6.87899 2.45634C6.87899 2.35396 6.92997 2.14926 6.98089 2.04693ZM19.3631 22.0043H4.586V12.5373H19.3631V22.0043ZM21.9618 10.5416H1.98727V7.5224H21.9618V10.5416Z"
              )
            span {{CERT.title}}

        .payment-options__cert(v-if="isShowCertInput")
          label(class="payment-options__cert-label") Введите номер подарочного сертификата:
          input(v-model="certNumber" ref="certNumberInput" maxlength="9" type="text" class="payment-options__cert-input")

</template>

<script>
import {PAYMENT_OPTIONS} from '@/store/consts/payment-options';
import {mapGetters, mapActions} from "vuex";

const CERT_VAL_LENGTH = 9;

export default {
  name: 'PaymentOption',
  data: () => {
    return {
      internalValue: null,
      certNumber: '',
      ...PAYMENT_OPTIONS,
    }
  },
  watch: {
    certNumber(newVal) {
      if (newVal.length < CERT_VAL_LENGTH) {
        this.value = null;
        this.internalValue = 'CERT';

        return;
      }

      this.value = this.CERT;
    }
  },
  computed: {
    ...mapGetters('places', {isPlacesValid: 'isValid'}),
    ...mapGetters('payment', {currentValue: 'getValue'}),
    objectClass() {
      return {
        'pane--closed': !this.isPlacesValid || false,
      }
    },
    value: {
      get() {
        return this.currentValue;
      },
      set(value) {
        this.internalValue = value?.value;

        if (value?.value === this.CERT.value && !this.isCertInputValid) {
          this.setPaymentOption(null);
          this.setCertNumber(this.certNumber);

          return;
        }

        this.setPaymentOption(value);
        this.setCertNumber('');
      },
    },
    isShowCertInput() {
      return this.internalValue === this.CERT.value;
    },
    isCertInputValid() {
      return this.certNumber.length === CERT_VAL_LENGTH;
    },
  },
  methods: {
    ...mapActions('payment', ['setPaymentOption', 'setCertNumber']),
    focusCertNumberInput() {
      setTimeout(() => {
        this.$refs.certNumberInput.focus();
      });
    }
  }
}
</script>
